import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperTaskTab: {
      display: "flex",
      flexDirection: "column",
      gap: "32px",
    },
    wrapperTaskCards: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      flexWrap: "wrap",
    },
  };
});
